import { render, staticRenderFns } from "./ProductWastageStatsPage.vue?vue&type=template&id=1daa2b1a&"
import script from "./ProductWastageStatsPage.vue?vue&type=script&lang=js&"
export * from "./ProductWastageStatsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports